import React, { useContext } from 'react';
import { styled } from '@mui/material';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { FinancialsDateProps } from './FinancialsDate.props';
import { classes, StyledGridDateBase } from './FinancialsDate.styles';


const FinancialsDate = ({ cell }: FinancialsDateProps) => {
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);

  const handleOnChange = (date: string) => {
    onCellsChanged([{ cell, value: date }]);
  };

  const { value, readOnly, disabled } = cell;

  return (
    <StyledGridDateBase
      // cell was added during ts migration
      cell={cell}
      className={classes.dateIcon}
      value={value as string}
      readOnly={readOnly}
      disabled={disabled}
      onCellsChanged={handleOnChange}
    />
  );
};

export default FinancialsDate;
